import React, { useState } from "react";
import PropTypes from "prop-types";
import { connect } from "unistore/preact";
import { actions } from "actions";
import { getTopmostPageUrl, getDeckState, isNullOrUndefOrEmpty, jsonToUri, toObject, windowPop } from "utils";
import { IconClose, IconDownCaret, IconGear, IconUpCaret } from "components/icons/Icons";
import { WidgetOverrideParams } from "consts";
import { envConfig } from "config";
import classNames from "classnames";

const { widgetAdmin1Url, widgetAdmin2Url } = envConfig;

//FIXME: SOF-617 requires the following imports to be moved to components/widget-components.scss
// due to lazy loading of the widget inside an iframe. Keeping this here for potential fix down the road.
// import 'components/editable/EditableToolsWrapper.scss';

const EditableToolsWrapper = ({
  showTools = false,
  positionableOn,
  positionable = {},
  onHideTools,
  instanceId,
  articleUrl,
  bootstrap,
  questionsData,
  questionIndex,
  widgetState,
  results = [],
  resultIndex,
}) => {
  if (!showTools || !bootstrap || !instanceId) {
    return null;
  }
  const [showAdminEditableMenu, setShowAdminEditableMenu] = useState(false);

  const onHideToolsWrapper = () => (onHideTools ? onHideTools() : false);
  const { askableId } = getDeckState({
    widgetState,
    questionsData,
    questionIndex,
    results,
    resultIndex,
  });

  const { oid, id } = toObject(bootstrap);
  const url = getTopmostPageUrl(articleUrl);

  const openWidgetAdmin = () => {
    const waParams = { tgt: id, otgt: oid, pgurl: url, elt: instanceId };
    if (!isNullOrUndefOrEmpty(askableId)) {
      waParams.a = askableId;
    }
    //default to WA2, and allow access to WA1 via csw-wa1=true in the publisher URL
    const isWidgetAdmin1 = url.includes(WidgetOverrideParams.WidgetAdmin1);
    const widgetAdminFullUrl = isWidgetAdmin1
      ? `${widgetAdmin1Url}?${jsonToUri(waParams)}`
      : `${widgetAdmin2Url}/protected/?${jsonToUri(waParams)}`;

    windowPop(widgetAdminFullUrl, "cswWidgetAdmin", 800, 400, 100, 100);
  };

  return (
    <>
      <div className={classNames("csw-editable-tools", { "csw-show-tools": showAdminEditableMenu })}>
        <div className="csw-editable-menu-top-actions">
          <button
            type="button"
            className="csw-editable-menu-btn outline"
            title="View widget without editable tools"
            aria-label="View widget without editable tools"
            onClick={onHideToolsWrapper}
          >
            <span className="csw-i">&#128065;</span>
          </button>
          <button
            type="button"
            className="csw-editable-menu-btn outline"
            title="Close editable menu"
            aria-label="Close editable menu"
            onClick={() => setShowAdminEditableMenu(false)}
          >
            <IconClose />
          </button>
        </div>

        <div
          className="csw-editable-tools-inject"
          data-civicscience-widget-positionable-on={positionableOn}
          data-civicscience-widget-position-resettable={positionableOn && !isNullOrUndefOrEmpty(positionable.p)}
        />
      </div>
      <button
        type="button"
        className="csw-editable-menu-btn csw-editable-menu-toggle outline"
        title={showAdminEditableMenu ? "Hide editable menu" : "Show editable menu"}
        aria-label={showAdminEditableMenu ? "Hide editable menu" : "Show editable menu"}
        onClick={() => setShowAdminEditableMenu(!showAdminEditableMenu)}
      >
        {showAdminEditableMenu ? <IconDownCaret /> : <IconUpCaret />}
      </button>
      <button
        type="button"
        className="csw-widget-admin-opener-btn outline"
        title="Open widget administration"
        onClick={openWidgetAdmin}
      >
        <IconGear />
      </button>
    </>
  );
};

EditableToolsWrapper.propTypes /* remove-proptypes */ = {
  showTools: PropTypes.bool,
  positionableOn: PropTypes.bool,
  positionable: PropTypes.object,
  onHideTools: PropTypes.func,
  instanceId: PropTypes.string,
  articleUrl: PropTypes.string,
  bootstrap: PropTypes.object,
  questionsData: PropTypes.object,
  questionIndex: PropTypes.number,
  results: PropTypes.array,
  resultIndex: PropTypes.number,
  widgetState: PropTypes.number,
};

export default connect(
  `bootstrap,config,instanceId,articleUrl,widgetState,questionsData,questionIndex,results,resultIndex`,
  actions,
)(EditableToolsWrapper);
